/**
 * Sens dans lequel les choix se rangent sous la question.
 *
 * En vertical, chaque choix prend toute la ligne : la liste se lit d'un coup d'œil, du premier au
 * dernier. En horizontal, ils se serrent à plusieurs par ligne, ce qui raccourcit la question au
 * prix de libellés plus étroits. Les valeurs sont celles du discriminant renvoyé par l'API.
 */
export enum CHOICES_LAYOUT {
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL',
}
